import React, {useEffect} from 'react';
import RestrictedNotice from "btdt/react/RestrictedNotice";
import LocationContact from "btdt/react/LocationContact";

export default function ProjectTypeStep({animating, types, title, chosenLocation, chosenType, handleTypeChange, handleNextStep}) {

    useEffect(() => {
        handleTypeChange(null)
    }, [])

    return (
        <div className={"container mx-auto px-4 lg:px-8"}>
            <div className={"grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-6"}>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <div className={"large-p"}>
                        {title}
                    </div>
                </div>
                {chosenLocation?.restricted && chosenLocation.restricted.length > 0 && (
                    <div className={"lg:col-span-8 lg:col-start-3"}>
                        <RestrictedNotice location={chosenLocation}/>
                    </div>
                )}
                <div className={"lg:col-span-8 grid grid-cols-subgrid gap-x-8 gap-y-5 lg:col-start-3"}>
                    {types.map(type => (
                        <div className={"lg:col-span-4 radio-option"} key={type.id}>
                            <input type="radio" name={'project-type'} id={`project-${type.id}`} value={type.id} className={"peer"} onChange={() => handleTypeChange(type)}/>
                            <label htmlFor={`project-${type.id}`} className={"check peer-checked:bg-brand-green-light"}>
                                {type.label}
                            </label>
                        </div>
                    ))}
                    <div className={"lg:col-span-8"}>
                        <button className={"btn"} disabled={animating || chosenType === null} onClick={handleNextStep}>
                            Next Step →
                        </button>
                    </div>
                </div>
                <div className={"lg:col-span-8 lg:col-start-3"}>
                    <LocationContact location={chosenLocation}/>
                </div>
            </div>
        </div>
    )
}